<template>
    <li class="nav-item">
        <a class="nav-link" @click="toggleFullscreen">
            <svg v-if="!fullscreen" viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2"
                fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
                    style="stroke-dasharray: 37, 57; stroke-dashoffset: 0;"></path>
            </svg>
            <svg v-else width="20" height="20" viewbox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minimize">
                <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
                    style="stroke-dasharray: 37, 57; stroke-dashoffset: 0;"></path>
            </svg>
        </a>
    </li>
</template>

<script setup>
import { ref } from 'vue'
const fullscreen = ref(false);

const toggleFullscreen = () => {
 
  if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
    exitFullscreen();
  } else {
    enterFullscreen();
  }
};

const enterFullscreen = () => {
  const element = document.documentElement;
  const requestFullscreen = element.requestFullscreen || element.webkitRequestFullscreen || element.mozRequestFullScreen || element.msRequestFullscreen;

  if (requestFullscreen) {
    requestFullscreen.call(element);
    fullscreen.value = true;
  }
};

const exitFullscreen = () => {
  const exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;

  if (exitFullscreen) {
    exitFullscreen.call(document);
    fullscreen.value = false;
  }
};

</script>

<style scoped>
    button {
        cursor: pointer;
    }
</style>
